import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { mainCategories } from "../../actions/categories";

class ShopByDepartment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mainCategories: [] };
  }

  async componentDidMount() {
    const mainCategories = await this.props.mainCategories();

    this.setState({ mainCategories: mainCategories.data });
  }

  render() {
    return (
      <div className="shop-by-department wrapper-90 max-1600">
        <div className="shop-by">
          <h3 className="shop-by-heading">Shop by Department</h3>
        </div>
        <div className="container-fluid px-0">
          <div className="row text-center  w-100 m-0">
            {this.state.mainCategories.length > 0 &&
              this.state.mainCategories.map((item, index) =>
                item &&
                item.show === true &&
                item.image &&
                item.slug !== "kitchen" ? (
                  <Fragment key={index}>
                    <div className="col-md-3 col-sm-4 col-6 shop-department-col">
                      <div className="sh-department-content">
                        <Link to={`/category/${item.slug}`}>
                          <div className="shop-images">
                            <LazyLoadImage
                              effect="blur"
                              src={item.image}
                              width="100%"
                              alt=""
                            />
                          </div>
                        </Link>
                        <p className="py-md-2 py-sm-0">
                          <Link to={`/category/${item.slug}`}>{item.name}</Link>
                        </p>
                      </div>
                    </div>
                  </Fragment>
                ) : null
              )}
          </div>
        </div>
      </div>
    );
  }
}

mainCategories.propTypes = {
  mainCategories: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  mainCategories: state.mainCategories,
});

export default connect(mapStateToProps, { mainCategories })(ShopByDepartment);
